import React, { Component } from "react";
import moment from "moment";
import "../../css/submissionFields.css";
import Autocomplete from "./Autocomplete";
import Dropdown from "./Dropdown";
import Button from "@material-ui/core/Button";
import InputLabel from "@material-ui/core/InputLabel";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import { DropzoneDialog } from "material-ui-dropzone";
import Tooltip from "@material-ui/core/Tooltip";
import Modal from "react-modal";
import DeleteIcon from "@material-ui/icons/Delete";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import Checkbox from "@material-ui/core/Checkbox";
import { DatePicker } from "@material-ui/pickers";
import CommonContants from "../../constants/CommonConstants";
import Loads from "../../components/loading/load";
import Snackbar from "@material-ui/core/Snackbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import InfoIcon from "@material-ui/icons/Info";

import Text from "../inputs/Text";
import ProductDetail from "../inputs/ProductDetail";
import AssetFileName from "../inputs/AssetFileName";
import OriginalAssetSeason from "../inputs/OriginalAssetSeason";
import Characters from "../inputs/Characters";

import ReactGA from "react-ga";

import { I18nContext } from "../../I18nProvider";

class AddProductModal extends Component {
  static contextType = I18nContext;

  constructor(props) {
    super(props);

    this.state = {
      supportingFilesOpen: false,
      filesOpen: false,
      isMounted: false,
      openSnackMsg: false,
      snackBarMsg: "Sample Msg",
      browserLang: "en-US",
    };

    this.handleClose = this.handleClose.bind(this);
  }

  componentDidMount() {
    Modal.setAppElement("#root");

    if (this.props.resetData === true) {
      this.props.data.licenseeRef = "";
      this.props.data.productDetail = "";
      this.props.data.productDetailID = null;
      this.props.data.originalSeason = "";
      this.props.data.assetFileName = "";
      this.props.data.assetFileID = null;
      this.props.data.originalAssetsParentRef = [];
      this.props.data.originalAssetsUID = [];
      this.props.data.retailerSKU = "";
      this.props.data.UPC = "";
      this.props.data.characters = [];
      this.props.data.charactersID = [];
      this.props.data.files = [];
      this.props.data.filesBatch = null;
      this.props.data.supportingFilesBatch = [];
      this.props.data.text = "";
    }

    if (
      this.props.resetData === true &&
      (this.props.type === "gte" || this.props.type === "product")
    ) {
      this.props.data.pricePointUSD = null;
      this.props.data.isDigitalContent = false;
      this.props.data.isPlush = false;
      this.props.data.isSoldInPackage = false;
      this.props.data.isSoldInSet = false;
    }

    if (this.props.resetData === true && this.props.type === "gte") {
      this.props.data.item = "";
      this.props.data.itemType = "";
      this.props.data.areaProduct = this.props.data.area;
      this.props.data.locationProduct = this.props.data.location;
      this.props.data.attractionProduct = this.props.data.attraction;
    }

    if (this.props.resetData === true && this.props.type === "publishing") {
      this.props.data.isbn13 = null;
      this.props.data.isbn10 = null;
      this.props.data.isPickup = false;
      this.props.data.pickupFile = [];
    }

    this.setState({ isMounted: true });

    // Date Localization
    const lang = navigator.language || navigator.userLanguage;
    if (lang && lang.toLowerCase().startsWith("ja")) {
      this.setState({ browserLang: "ja-JP" });
    } else {
      this.setState({ browserLang: "en-US" });
    }
  }

  handleOpen = (name) => {
    this.setState({ [name]: true });
  };

  handleClose = (name) => {
    this.setState({ [name]: false });
  };

  checkRequiredFields = () => {
    if (this.props.type !== "publishing") {
      for (var item of this.props.data.modalrequiredFields) {
        if (
          this.props.data[item] === null ||
          this.props.data[item] === "" ||
          (typeof this.props.data[item] === "object" &&
            this.props.data[item].length === 0)
        ) {
          if (item === "files") {
            this.setState({
              openSnackMsg: true,
              snackBarMsg: "Upload design file is required to proceed",
            });
          } else {
            item = item.replace(/([A-Z])/g, " $1").trim();
            item = item[0].toUpperCase() + item.slice(1);
            this.setState({
              openSnackMsg: true,
              snackBarMsg: `${item} is required to proceed`,
            });
          }
          return false;
        }
      }
    } else {
      if (this.props.data.isPickup === false) {
        for (var item of this.props.data.modalrequiredFields) {
          if (
            this.props.data[item] === null ||
            this.props.data[item] === "" ||
            (typeof this.props.data[item] === "object" &&
              this.props.data[item].length === 0)
          ) {
            if (item === "productDetail") {
              this.setState({
                openSnackMsg: true,
                snackBarMsg: `Format is required to proceed`,
              });
            } else {
              this.setState({
                openSnackMsg: true,
                snackBarMsg: `Pickup File is required to proceed`,
              });
            }
            return false;
          }
        }
      } else {
        for (var item of this.props.data.modalrequiredFields2) {
          if (
            this.props.data[item] === null ||
            this.props.data[item] === "" ||
            (typeof this.props.data[item] === "object" &&
              this.props.data[item].length === 0)
          ) {
            this.setState({
              openSnackMsg: true,
              snackBarMsg: `${item} is required to proceed`,
            });
            return false;
          }
        }
      }
    }
  };

  render() {
    const appText = this.context;
    var data = this.props.data;

    if (this.state.isMounted === true) {
      return (
        <Modal
          isOpen={true}
          onRequestClose={() => this.props.handleChange("modalOpened", false)}
          center
          style={{
            content: {
              top: "10%",
              bottom: "10%",
              padding: "2%",
            },
          }}
        >
          <Grid>
            <Grid item={true} xs={12}>
              {/* <h4>Add Design</h4> */}
              <h4>{appText.T78}</h4>
            </Grid>
            <Grid container spacing={2}>
              <Text
                inputName={
                  this.props.type !== "publishing" ? appText.T79 : appText.T306
                }
                value={data.licenseeRef}
                field="licenseeRef"
                // message={CommonContants.LICENSEE_REF_MESSAGE}
                message={appText.T127}
                handleChange={this.props.handleChange}
                isRequired={true}
              />

              <Text
                // inputName="Retailer SKU"
                inputName={appText.T80}
                value={data.retailerSKU}
                field="retailerSKU"
                // message={CommonContants.RETAILER_SKU_MESSAGE}
                message={appText.T128}
                handleChange={this.props.handleChange}
              />

              {this.props.type !== "publishing" ? (
                <Text
                  // inputName="UPC
                  inputName={appText.T81}
                  value={data.UPC}
                  field="UPC"
                  // message={CommonContants.UPC_MESSAGE}
                  message={appText.T129}
                  handleChange={this.props.handleChange}
                />
              ) : null}

              {this.props.type === "publishing" ? (
                <Text
                  // inputName="ISBN-10 / UPC"
                  inputName={appText.T308}
                  value={data.isbn10}
                  field="isbn10"
                  message={CommonContants.ISBN10_MESSAGE}
                  handleChange={this.props.handleChange}
                />
              ) : null}

              {this.props.type === "publishing" ? (
                <Text
                  // inputName="ISBN-13"
                  inputName={appText.T309}
                  value={data.isbn13}
                  field="isbn13"
                  message={CommonContants.ISBN13_MESSAGE}
                  handleChange={this.props.handleChange}
                />
              ) : null}

              <ProductDetail
                value={data.productDetail}
                contractID={data.contractID}
                handleChange={this.props.handleChange}
                type={this.props.type === "publishing" ? "publishing" : ""}
              />

              {this.props.type === "publishing" ? (
                <Grid item xs={3}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                    }}
                  >
                    <Checkbox
                      color="primary"
                      checked={data.isPickup}
                      value="Pickup?"
                      onClick={(e) => {
                        this.props.handleCheckboxChange("isPickup");
                      }}
                    ></Checkbox>
                    <InputLabel className="field-label field-text">
                      {/* Pickup? */}
                      {appText.T311}
                    </InputLabel>
                  </div>
                </Grid>
              ) : null}

              {this.props.type === "publishing" && data.isPickup === true ? (
                <Tooltip
                  arrow
                  // title="Please, include the file name of any assets used or referenced in this submission"
                  title={appText.T132}
                  required
                >
                  <Grid item={true} xs={12}>
                    <div id="assetFileName">
                      <InputLabel
                        className="field-label field-dropdown"
                        required
                      >
                        Pickup File
                      </InputLabel>
                      <Dropdown
                        data={data.fetchedPickupFiles}
                        value={data.pickupFile}
                        handleChange={this.props.handleMultipleChange}
                        loadData={this.props.loadPickups}
                        type={"pickupFile"}
                        handlePickUps={this.props.handlePickUps}
                      />
                    </div>
                  </Grid>
                </Tooltip>
              ) : null}

              {this.props.type !== "publishing" ? (
                <OriginalAssetSeason
                  value={data.originalSeason}
                  handleChange={this.props.handleChange}
                  propertyID={data.propertyID}
                />
              ) : null}

              <AssetFileName
                isRequired={this.props.type === "publishing" ? false : true}
                parentRef={data.originalAssetsParentRef}
                value={data.assetFileName}
                id={data.originalAssetsUID}
                handleChange={this.props.handleChange}
                fetchedLicensees={data.fetchedLicensees}
                fetchedProperty={data.fetchedProperty}
              />

              <Characters
                value={data.characters}
                id={data.charactersID}
                propertyID={data.propertyID}
                handleChange={this.props.handleChange}
                assetFileID={data.assetFileID}
                type={this.props.type}
              />

              {this.props.type === "gte" ? (
                <Tooltip arrow title="Please, select the location">
                  <Grid item={true} xs={12}>
                    <div id="location">
                      <InputLabel
                        className="field-label field-dropdown"
                        required
                      >
                        {/* Location */}
                        {appText.T345}
                      </InputLabel>
                      <Autocomplete
                        type={"multi"}
                        handleChange={this.props.handleMultipleChange}
                        data={data.fetchedLocations}
                        dataType={"locationProduct"}
                        mapVariable={"title"}
                        value={data.locationProduct}
                        isLoading={false}
                      />
                    </div>
                  </Grid>
                </Tooltip>
              ) : null}

              {this.props.type === "gte" ? (
                <Tooltip arrow title="Please, select the area">
                  <Grid item={true} xs={12}>
                    <div id="area">
                      <InputLabel className="field-label field-dropdown">
                        {/* Area */}
                        {appText.T346}
                      </InputLabel>
                      <Autocomplete
                        type={"multi"}
                        handleChange={this.props.handleMultipleChange}
                        data={data.fetchedAreas}
                        dataType={"areaProduct"}
                        mapVariable={"title"}
                        value={data.areaProduct}
                        setFilterData={() => null}
                        isLoading={false}
                      />
                    </div>
                  </Grid>
                </Tooltip>
              ) : null}

              {this.props.type === "gte" ? (
                <Tooltip arrow title="Please, select the attraction">
                  <Grid item={true} xs={12}>
                    <div id="attraction">
                      <InputLabel className="field-label field-dropdown">
                        {/* Attraction */}
                        {appText.T347}
                      </InputLabel>
                      <Autocomplete
                        type={"multi"}
                        handleChange={this.props.handleMultipleChange}
                        data={data.fetchedAttractions}
                        dataType={"attractionProduct"}
                        mapVariable={"title"}
                        value={data.attractionProduct}
                        setFilterData={() => {}}
                        isLoading={false}
                      />
                    </div>
                  </Grid>
                </Tooltip>
              ) : null}

              {this.props.type === "gte" ? (
                <Tooltip arrow title="Please, enter item">
                  <Grid item={true} xs={12}>
                    <div>
                      <InputLabel className="field-label field-text">
                        {/* Item */}
                        {appText.T372}
                      </InputLabel>
                      <TextField
                        style={{ marginTop: 5, fontSize: 16, height: 30 }}
                        value={data.item}
                        type="text"
                        aria-label="minimum height"
                        rows={1}
                        fullWidth={true}
                        className="textArea-field"
                        onChange={(event) =>
                          this.props.handleChange("item", event.target.value)
                        }
                      />
                    </div>
                  </Grid>
                </Tooltip>
              ) : null}

              {this.props.type === "gte" ? (
                <Tooltip arrow title="Please, enter item type">
                  <Grid item={true} xs={12}>
                    <div>
                      <InputLabel className="field-label field-text">
                        {/* Item Type */}
                        {appText.T373}
                      </InputLabel>
                      <Autocomplete
                        type={"single"}
                        handleChange={(values) => {
                          if (values === null) {
                            this.props.handelChangeAutocomplete("itemType", "");
                          } else {
                            this.props.handelChangeAutocomplete(
                              "itemType",
                              values[values.length - 1].label
                            );
                          }
                        }}
                        data={data.fetchedItemType}
                        dataType={"itemType"}
                        mapVariable={"label"}
                        value={data.itemType}
                        setFilterData={() => null}
                        isLoading={false}
                        isNotRequired={true}
                      />
                    </div>
                  </Grid>
                </Tooltip>
              ) : null}

              {this.props.type !== "publishing" ? (
                <Tooltip
                  arrow
                  // title="Please, include any relevant T&V from product for this submission"
                  title={appText.T134}
                >
                  <Grid item={true} xs={12}>
                    <InputLabel className="field-label field-text">
                      {/* Text/Verbiage on Product */}
                      {appText.T88}
                    </InputLabel>
                    <TextField
                      style={{ marginTop: 5, fontSize: 16, height: 30 }}
                      value={data.text}
                      aria-label="minimum height"
                      rows={1}
                      fullWidth={true}
                      className="textArea-field"
                      onChange={(event) =>
                        this.props.handleChange("text", event.target.value)
                      }
                    />
                  </Grid>
                </Tooltip>
              ) : null}

              <Tooltip
                arrow
                // title="Please, enter the date the product being marketed will enter the market"
                title={appText.T135}
              >
                <Grid item={true} xs={12}>
                  <div>
                    {this.props.type === "publishing" ? (
                      <InputLabel className="field-label field-datePicker">
                        {/* On Sale Date */}
                        {appText.T316}
                      </InputLabel>
                    ) : (
                      <InputLabel className="field-label field-datePicker">
                        {/* On-shelf Date */}
                        {appText.T59}
                      </InputLabel>
                    )}
                    {this.state.browserLang === "ja-JP" ? (
                      <DatePicker
                        fullWidth={true}
                        placeholder="YYYY-MM-DD"
                        value={data.onShelfDate}
                        onChange={(date) =>
                          this.props.handleChange(
                            "onShelfDate",
                            moment(date).format("YYYY-MM-DD")
                          )
                        }
                        format={"YYYY-MM-DD"}
                      ></DatePicker>
                    ) : (
                      <DatePicker
                        fullWidth={true}
                        placeholder="MM/DD/YYYY"
                        value={data.onShelfDate}
                        onChange={(date) =>
                          this.props.handleChange(
                            "onShelfDate",
                            moment(date).format(
                              CommonContants.FIELD_DATE_FORMAT
                            )
                          )
                        }
                        format={CommonContants.FIELD_DATE_FORMAT}
                      ></DatePicker>
                    )}
                  </div>
                </Grid>
              </Tooltip>

              {this.props.type === "publishing" ? (
                <Tooltip
                  arrow
                  title="Please, include cover price for this submission"
                >
                  <Grid item={true} xs={12}>
                    <InputLabel className="field-label field-text">
                      {/* Cover Price */}
                      {appText.T319}
                    </InputLabel>
                    <TextField
                      style={{ marginTop: 5, fontSize: 16, height: 30 }}
                      aria-label="minimum height"
                      rows={1}
                      fullWidth={true}
                      value={data.coverPrice}
                      className="textArea-field"
                      onChange={(event) =>
                        this.props.handleChange(
                          "coverPrice",
                          event.target.value
                        )
                      }
                    />
                  </Grid>
                </Tooltip>
              ) : null}

              {this.props.type === "product" || this.props.type === "gte" ? (
                <Tooltip arrow title="Please, enter price point in USD">
                  <Grid item={true} xs={12}>
                    <div>
                      <InputLabel className="field-label field-text">
                        {/* Price Point (USD) */}
                        {appText.T92}
                      </InputLabel>
                      <TextField
                        style={{ marginTop: 5, fontSize: 16, height: 30 }}
                        value={data.pricePointUSD}
                        fullWidth={true}
                        aria-label="minimum height"
                        className="textArea-field"
                        onChange={(event) =>
                          this.props.handleChange(
                            "pricePointUSD",
                            event.target.value
                          )
                        }
                      />
                    </div>
                  </Grid>
                </Tooltip>
              ) : null}

              {this.props.type === "product" || this.props.type === "gte" ? (
                <Grid container spacing={3}>
                  <Grid item xs={3}>
                    <div>
                      <Checkbox
                        style={{ marginLeft: "10%" }}
                        color="primary"
                        checked={data.isSoldInPackage}
                        value="Sold in package"
                        onClick={(e) => {
                          this.props.handleCheckboxChange("isSoldInPackage");
                        }}
                      ></Checkbox>
                      <InputLabel className="field-label field-text">
                        {/* Sold in package? */}
                        {appText.T93}
                      </InputLabel>
                    </div>
                  </Grid>
                  <Grid item xs={3}>
                    <div>
                      <Checkbox
                        style={{ marginLeft: "10%" }}
                        color="primary"
                        checked={data.isSoldInSet}
                        value="Sold in set"
                        onClick={(e) => {
                          this.props.handleCheckboxChange("isSoldInSet");
                        }}
                      ></Checkbox>
                      <InputLabel
                        className="field-label field-text"
                        style={{ marginLeft: "5%" }}
                      >
                        {/* Sold in set? */}
                        {appText.T94}
                      </InputLabel>
                    </div>
                  </Grid>
                  <Grid item xs={3}>
                    <div>
                      <Checkbox
                        style={{ marginLeft: "10%" }}
                        color="primary"
                        checked={data.isDigitalContent}
                        value="Digital content?"
                        onClick={(e) => {
                          this.props.handleCheckboxChange("isDigitalContent");
                        }}
                      ></Checkbox>
                      <InputLabel className="field-label field-text">
                        {/* Digital content? */}
                        {appText.T95}
                      </InputLabel>
                    </div>
                  </Grid>
                  <Grid item xs={3}>
                    <div>
                      <Checkbox
                        style={{ marginLeft: "10%" }}
                        color="primary"
                        checked={data.isPlush}
                        value="Plush"
                        onClick={(e) => {
                          this.props.handleCheckboxChange("isPlush");
                        }}
                      ></Checkbox>
                      <InputLabel
                        className="field-label field-text"
                        style={{ marginLeft: "10%" }}
                      >
                        {/* Plush? */}
                        {appText.T96}
                      </InputLabel>
                    </div>
                  </Grid>
                </Grid>
              ) : null}

              {this.props.type !== "publishing" ? (
                <Grid xs={12} item={true} className="file-upload-container">
                  <div id="design-file">
                    <Grid style={{ padding: "1rem 0" }} item xs={12}>
                      <h8>
                        <b>
                          <u>{appText.T72}</u>
                        </b>
                      </h8>
                      {/* <div>
                        Design File uploads are limited to only <b>1</b> file.
                        Supporting Materials are limited to <b>20</b> files.
                      </div> */}
                      <div>
                        {appText.T273 &&
                          appText.T273.split(/(1|20)/).map((text, index) => {
                            if (text === "1") {
                              return <b key={index}>1</b>;
                            }
                            if (text === "20") {
                              return <b key={index}>20</b>;
                            }
                            return text;
                          })}
                      </div>
                      <div>
                        <h8 style={{ color: "red" }}>
                          {/* Please ensure legal line is visible on submission. */}
                          {appText.T77}
                        </h8>
                      </div>
                    </Grid>
                    <Tooltip arrow title={appText.T137}>
                      <Button
                        variant="outlined"
                        onClick={() => this.handleOpen("filesOpen")}
                        disabled={data.areFilesUploading}
                        style={{ width: "50%" }}
                      >
                        <div id="button-name-container">
                          {/* <div>Upload Design</div> */}
                          <div>{appText.T100}</div>
                          <div id="button-required">*</div>
                        </div>
                      </Button>
                    </Tooltip>

                    <DropzoneDialog
                      open={this.state.filesOpen}
                      onSave={(files) => {
                        this.props.handleSave("files", files);
                        console.log(files);
                        ReactGA.event({
                          category: "Form",
                          action: "Design File Uploaded",
                          transport: "beacon",
                          label: `Uploaded - ${files[0].name}`,
                        });
                        this.handleClose("filesOpen");
                      }}
                      showPreviews={true}
                      showFileNames={true}
                      acceptedFiles={[
                        "audio/*, image/*, video/*",
                        "application/*",
                      ]}
                      filesLimit={1}
                      maxFileSize={5000000000}
                      onClose={() => this.handleClose("filesOpen")}
                    />

                    <div style={{ width: "50%" }}>
                      <Loads hidden={!data.areFilesUploading}></Loads>
                    </div>
                    {data.files.map((item, id) => {
                      return (
                        <div
                          style={{
                            display: data.areFilesUploading ? "none" : "flex",
                          }}
                          key={id}
                          className="file-uploaded"
                        >
                          <span className="file-name">{item.name}</span>
                          <div className="check-circle-icon">
                            <Tooltip title="Done">
                              <CheckCircleIcon />
                            </Tooltip>
                          </div>
                          <div
                            className="trash-icon"
                            onClick={() => this.handleRemoveFile("files", item)}
                          >
                            <Tooltip title="Delete">
                              <DeleteIcon />
                            </Tooltip>
                          </div>
                        </div>
                      );
                    })}
                  </div>

                  <div
                    id="supporting-file"
                    style={{
                      paddingLeft: 0,
                    }}
                  >
                    <Button
                      variant="outlined"
                      onClick={() => this.handleOpen("supportingFilesOpen")}
                      disabled={data.areSupportingFilesUploading}
                      style={{ width: "50%" }}
                    >
                      {/* Upload Supporting Material */}
                      {appText.T101}
                    </Button>
                    <DropzoneDialog
                      open={this.state.supportingFilesOpen}
                      onSave={(files) => {
                        files.forEach((file, index) => {
                          var array = [];
                          array.push(file);
                          if (index === files.length - 1) {
                            this.props.handleSave(
                              "supportingFiles",
                              array,
                              true
                            );
                          } else {
                            this.props.handleSave("supportingFiles", array);
                          }
                          array.slice(0, 1);
                        });
                        ReactGA.event({
                          category: "Form",
                          action: "Supporting Materials Uploaded",
                          transport: "beacon",
                          label: `Uploaded - ${files.length} Supporting Materials`,
                        });
                        this.handleClose("supportingFilesOpen");
                      }}
                      showPreviews={true}
                      showFileNames={true}
                      showAlerts={["error", "success", "info"]}
                      maxFileSize={5000000000}
                      acceptedFiles={[
                        "audio/*, image/*, video/*",
                        "application/*",
                      ]}
                      filesLimit={20}
                      onClose={() => this.handleClose("supportingFilesOpen")}
                    />

                    <div style={{ width: "50%" }}>
                      <Loads hidden={!data.areSupportingFilesUploading}></Loads>
                    </div>
                    {data.supportingFilesBatch.map((item, id) => {
                      return (
                        <div
                          style={{
                            display: data.areSupportingFilesUploading
                              ? "none"
                              : "flex",
                          }}
                          key={id}
                          className="file-uploaded"
                        >
                          <span className="file-name">{item.name}</span>
                          <div className="check-circle-icon">
                            <Tooltip title="Done">
                              <CheckCircleIcon />
                            </Tooltip>
                          </div>
                          <div
                            className="trash-icon"
                            onClick={() =>
                              this.handleRemoveFile("supportingFiles", item)
                            }
                          >
                            <Tooltip title={`Delete ${item}`}>
                              <DeleteIcon />
                            </Tooltip>
                          </div>
                        </div>
                      );
                    })}
                    {/* </Grid> */}
                  </div>
                </Grid>
              ) : null}

              <Grid container spacing={4}>
                <Grid item={true} xs={6}>
                  <div
                    style={{
                      padding:
                        this.props.type === "publishing"
                          ? "32px 0px 0px 8px"
                          : "0px 0px 0px 8px",
                      display: "flex",
                      justifyContent: "flex-start",
                    }}
                  >
                    <Button
                      variant="outlined"
                      style={{ marginRight: "1.5%" }}
                      onClick={this.props.onCloseModal}
                    >
                      {/* Cancel */}
                      {appText.T104}
                    </Button>
                    {this.props.type !== "publishing" ? (
                      data.licenseeRef &&
                      data.productDetail &&
                      (data.files.length > 0 || data.filesBatch) &&
                      !data.areFilesUploading &&
                      !data.areSupportingFilesUploading &&
                      data.characters.length > 0 &&
                      data.assetFileName.length > 0 ? (
                        <Button
                          variant="outlined"
                          onClick={this.props.handleSubmitModal}
                          type="submit"
                          value="OK"
                        >
                          {" "}
                          {appText.T448}{" "}
                        </Button>
                      ) : (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-start",
                          }}
                        >
                          <span
                            onClick={this.checkRequiredFields}
                            style={{
                              display: "inline-block",
                              width: "auto",
                            }}
                          >
                            <Button
                              variant="outlined"
                              onClick={this.props.handleSubmitModal}
                              type="submit"
                              disabled
                              value="OK"
                            >
                              {" "}
                              {appText.T448}{" "}
                            </Button>
                          </span>
                        </div>
                      )
                    ) : data.isPickup ? (
                      data.productDetail && data.pickupFile.length > 0 ? (
                        <Button
                          variant="outlined"
                          onClick={this.props.handleSubmitModal}
                          type="submit"
                          value="OK"
                        >
                          {" "}
                          {appText.T448}{" "}
                        </Button>
                      ) : (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-start",
                          }}
                        >
                          <span
                            onClick={this.checkRequiredFields}
                            style={{
                              display: "inline-block",
                              width: "auto",
                            }}
                          >
                            <Button
                              variant="outlined"
                              onClick={this.props.handleSubmitModal}
                              type="submit"
                              disabled
                              value="OK"
                            >
                              {" "}
                              {appText.T448}{" "}
                            </Button>
                          </span>
                        </div>
                      )
                    ) : data.productDetail ? (
                      <Button
                        variant="outlined"
                        onClick={this.props.handleSubmitModal}
                        type="submit"
                        value="OK"
                      >
                        {" "}
                        {appText.T448}{" "}
                      </Button>
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                        }}
                      >
                        <span
                          onClick={this.checkRequiredFields}
                          style={{
                            display: "inline-block",
                            width: "auto",
                          }}
                        >
                          <Button
                            variant="outlined"
                            onClick={this.props.handleSubmitModal}
                            type="submit"
                            disabled
                            value="OK"
                          >
                            {" "}
                            {appText.T448}{" "}
                          </Button>
                        </span>
                      </div>
                    )}
                  </div>
                </Grid>
              </Grid>
            </Grid>

            <div className="snack-bar-container">
              <Snackbar
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                open={data.openSnackMsg}
                onClose={() => this.props.handleChange("openSnackMsg", false)}
                autoHideDuration={6000}
                ContentProps={{
                  "aria-describedby": "snack-bar-msg",
                }}
                message={
                  <div className="snack-bar-msg-content">
                    <span className="snack-bar-msg-icon">
                      <InfoIcon></InfoIcon>
                    </span>
                    <span className="snack-bar-msg">
                      {this.state.snackBarMsg}
                    </span>
                  </div>
                }
                action={[
                  <IconButton
                    key="close"
                    aria-label="close"
                    color="inherit"
                    className="snack-msg-close-icon"
                    onClick={() =>
                      this.props.handleChange("openSnackMsg", false)
                    }
                  >
                    <CloseIcon />
                  </IconButton>,
                ]}
              />
            </div>
          </Grid>
        </Modal>
      );
    } else return null;
  }
}

export default AddProductModal;
